var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', {
    staticClass: "mb-3 align-items-center"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('date-picker', {
    staticClass: "mr-2 w-100",
    attrs: {
      "placeholder": "Date Range",
      "range": ""
    },
    on: {
      "input": function input($event) {
        return _vm.emitParams();
      }
    },
    model: {
      value: _vm.localParams.dateRange,
      callback: function callback($$v) {
        _vm.$set(_vm.localParams, "dateRange", $$v);
      },
      expression: "localParams.dateRange"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('v-multiselect', {
    staticClass: "mr-2",
    attrs: {
      "placeholder": "Search Fleet Type",
      "label": "label",
      "options": _vm.optionsVehicleType,
      "multiple": true,
      "required": "",
      "track-by": "value"
    },
    on: {
      "input": function input($event) {
        return _vm.emitParams();
      }
    },
    model: {
      value: _vm.localParams.fleet_category,
      callback: function callback($$v) {
        _vm.$set(_vm.localParams, "fleet_category", $$v);
      },
      expression: "localParams.fleet_category"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Fleet type not found.")])])], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('v-multiselect', {
    staticClass: "mr-2",
    attrs: {
      "placeholder": "Search Fleet Name",
      "label": "label",
      "options": _vm.optionsFleets,
      "multiple": true,
      "required": "",
      "track-by": "value"
    },
    on: {
      "input": function input($event) {
        return _vm.emitParams();
      }
    },
    model: {
      value: _vm.localParams.fleet_id,
      callback: function callback($$v) {
        _vm.$set(_vm.localParams, "fleet_id", $$v);
      },
      expression: "localParams.fleet_id"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Fleet name not found.")])])], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('v-multiselect', {
    attrs: {
      "options": _vm.statusOptions,
      "multiple": true,
      "label": "label",
      "track-by": "value"
    },
    on: {
      "input": function input($event) {
        return _vm.emitParams();
      }
    },
    model: {
      value: _vm.localParams.status,
      callback: function callback($$v) {
        _vm.$set(_vm.localParams, "status", $$v);
      },
      expression: "localParams.status"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('onFilter');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }